import { GetterTree } from 'vuex';
import { ProfessionalState, RootState } from './professional-types';

export const getters: GetterTree<ProfessionalState, RootState> = {
  skillsProfessions: (state) => state.professional?.body,
  // skillsEmployeeProfile(state): string {
  //   const { user } = state;
  //   console.log('email', user);
  //   console.log('state', state);
  //   const email = (user && user.email) || 'saifi.razique@nile';
  //   console.log('email2', email);
  //   // const firstName = (user && user.firstName) || '';
  //   // const lastName = (user && user.lastName) || '';
  //   // return `${firstName} ${lastName}`;
  //   return email;
  // },
};
